import React from "react";
var __jsx = React.createElement;
import { LogoWrapper, TextWrapper, Wrapper } from './Wrapper';
var defaultFooterText = "This video landing page created in";

var Footer = function Footer(_ref) {
  var _ref$footerText = _ref.footerText,
      footerText = _ref$footerText === void 0 ? defaultFooterText : _ref$footerText,
      fontStyles = _ref.fontStyles;
  return __jsx(Wrapper, null, __jsx(TextWrapper, {
    fontStyles: fontStyles
  }, __jsx("p", {
    dangerouslySetInnerHTML: {
      __html: footerText
    }
  }), __jsx(LogoWrapper, {
    src: "images/video-landings/icons/wv-text-logo.svg",
    alt: "Wave video",
    width: "80",
    height: "14"
  })));
};

export default Footer;